const organisation = "ayaam";

const host = process.env.NODE_ENV === 'production' ? "http://webservice.sysbrew.in/ayaam_sm/" : "http://webservice.sysbrew.in/ayaam_sm/";

const Config = {
    token : "NjYzYzgyNzYyNGNmOWQzMmJjNzcxNjU2YTkwMDVmYjhlMDEzNGE3NThkNjExMWJjZWZhZGUwZGU1NDE2OGI1Ng==",
    get_routes: `${host}get_routes.php?organisation=${organisation}&`,
    get_detailed_routes: `${host}get_detailed_routes.php?organisation=${organisation}&`,
    remove_route: `${host}remove_route.php?organisation=${organisation}&`,
    create_route: `${host}create_route.php?organisation=${organisation}&`,
    assign_route: `${host}assign_route.php?organisation=${organisation}&`,
    assign_store_route: `${host}assign_store_route.php?organisation=${organisation}&`,
    get_route_area: `${host}get_route_area.php?organisation=${organisation}&`,
    remove_agent_assignment: `${host}remove_agent_assignment.php?organisation=${organisation}&`,
    remove_store_assignment: `${host}remove_store_assignment.php?organisation=${organisation}&`,
    authenticate_url: `${host}authenticate.php?organisation=${organisation}&`,
    get_products_url: `${host}get_products.php?organisation=${organisation}&`,
    create_product: `${host}create_product.php?organisation=${organisation}&`,
    mark_product_glass: `${host}mark_product_glass.php?organisation=${organisation}&`,
    get_agents_url: `${host}get_users.php?organisation=${organisation}&type=AGENT&`,
    get_stores_url: `${host}get_users.php?organisation=${organisation}&type=STORE&`,
    get_stores_export: `${host}get_stores_export.php?organisation=${organisation}&type=STORE&`,
    get_contracts_for_store: `${host}get_contracts_for_store.php?organisation=${organisation}&type=STORE&`,
    get_customers_url: `${host}get_users.php?organisation=${organisation}&type=CUSTOMER&`,
    create_agent: `${host}create_agent.php?organisation=${organisation}&type=AGENT&`,
    create_store: `${host}create_store.php?organisation=${organisation}&type=STORE&`,
    remove_agent: `${host}remove_user.php?organisation=${organisation}&type=AGENT&`,
    remove_store: `${host}remove_user.php?organisation=${organisation}&type=STORE&`,
    update_bottles_returned: `${host}update_bottles_returned.php?organisation=${organisation}&`,    
    add_tag: `${host}add_tag.php?organisation=${organisation}&`,
    get_user_locations: `${host}get_user_locations.php?organisation=${organisation}&`,
    request_user_location: `${host}request_user_location.php?organisation=${organisation}&`,
    toggle_user_status: `${host}toggle_user_status.php?organisation=${organisation}&`,
    google_url: "http://maps.google.com?q=",
    get_customer_names: `${host}get_customer_names.php?organisation=${organisation}&`,
    export_excel: `${host}export_excel.php?organisation=${organisation}&`,
    mark_delivery: `${host}mark_delivery.php?organisation=${organisation}&`,
    notify_user_schedules_ready: `${host}notify_user_schedules_ready.php?organisation=${organisation}&`,
    get_store_routes: `${host}get_store_routes.php?organisation=${organisation}&`,
    get_store_delivery_schedule: `${host}get_store_delivery_schedules.php?organisation=${organisation}&`,
    get_store_delivery_schedule_marker: `${host}get_store_delivery_schedule_marker.php?organisation=${organisation}&`,
    create_delivery: `${host}create_delivery.php?organisation=${organisation}&`,
    remove_delivery: `${host}remove_delivery.php?organisation=${organisation}&`,
    resend_invoice: `${host}resend_invoice.php?organisation=${organisation}&`,

    // import
    upload_map_url: `${host}upload_map.php?organisation=${organisation}&`,
    upload_url: `${host}import_schedule.php?organisation=${organisation}&`,
    reassign_routes: `${host}reassign_routes_as_per_mapping.php?organisation=${organisation}&`,

    // Promotions
    get_promotions_url: `${host}get_promotions.php?organisation=${organisation}&`,
    get_promotiondetails: `${host}get_promotiondetails.php?organisation=${organisation}&`,
    toggle_promotion_status: `${host}toggle_promotion_status.php?organisation=${organisation}&`,
    create_promotion: `${host}create_promotion.php?organisation=${organisation}&`,
    remove_promotion: `${host}remove_promotion.php?organisation=${organisation}&`,

    // Reports
    report_summary:`${host}report_summary.php?organisation=${organisation}&`,
    report_schedule:`${host}report_schedule.php?organisation=${organisation}&`,
    report_max : `${host}report_max.php?organisation=${organisation}&`,
    report_pending_bottles:`${host}report_pending_bottles.php?organisation=${organisation}&`,
    report_pending_bottles_detailed: `${host}report_pending_bottles_detailed.php?organisation=${organisation}&`,
    report_sales_stats: `${host}report_sales_stats.php?organisation=${organisation}&`,
    get_customer_transactions: `${host}get_customer_transactions.php?organisation=${organisation}&`,
    get_agent_transactions: `${host}get_agent_transactions.php?organisation=${organisation}&`,
    get_agent_transactions_summary: `${host}get_agent_transactions_summary.php?organisation=${organisation}&`,
    get_agent_transactions_summary_mismatch_txn: `${host}get_agent_transactions_summary_mismatch_txn.php?organisation=${organisation}&`,
    report_sales_report: `${host}sales_report.php?organisation=${organisation}&`,
    report_store_b2w: `${host}report_store_b2w.php?organisation=${organisation}&`,
    report_product_trend_by_user: `${host}report_product_trend_by_user.php?organisation=${organisation}&`,
    report_performance_by_user: `${host}report_performance_by_user.php?organisation=${organisation}&`,
    report_product_stats_by_user: `${host}report_product_stats_by_user.php?organisation=${organisation}&`,

    // Tools
    send_notification: `${host}generic_send_notification.php?organisation=${organisation}&`,
    get_reason_by_type: `${host}get_reason_by_type.php?organisation=${organisation}&`,
    create_reason: `${host}create_reason.php?organisation=${organisation}&`,
    remove_reason: `${host}remove_reason.php?organisation=${organisation}&`,
    get_organisation_details: `${host}get_organisation_details.php?organisation=${organisation}&`,
    update_organisation_information: `${host}update_organisation_information.php?organisation=${organisation}&`,
    reset_invoice_no: `${host}reset_invoice_no.php?organisation=${organisation}&`,

    // WareHouse
    get_warehouses_url: `${host}get_warehouses.php?organisation=${organisation}&`,
    remove_wh: `${host}remove_wh.php?organisation=${organisation}&`,
    create_wh: `${host}create_wh.php?organisation=${organisation}&`,
    toggle_wh_status: `${host}toggle_wh_status.php?organisation=${organisation}&`,
    get_inventory_transactions: `${host}get_inventory_transactions.php?organisation=${organisation}&`,
    get_inventory_transactions_for_sd: `${host}get_inventory_transactions_for_sd.php?organisation=${organisation}&`,
    create_inventory_transaction: `${host}create_inventory_transaction.php?organisation=${organisation}&`,
    get_inventory_summary: `${host}get_inventory_summary.php?organisation=${organisation}&`,
    get_inventory_batchwise_summary: `${host}get_inventory_batchwise_summary.php?organisation=${organisation}&`,
    remove_inventory_transaction: `${host}remove_inventory_transaction.php?organisation=${organisation}&`,

    // Payment
    update_payment: `${host}update_payment_details.php?organisation=${organisation}&`,
    get_payment_transactions : `${host}get_payment_transactions.php?organisation=${organisation}&`,


    //NEW

    // TOOLS
    get_job_actions: `${host}get_job_actions.php?organisation=${organisation}&`,
    create_job_action: `${host}create_job_action.php?organisation=${organisation}&`,
    remove_job_action: `${host}remove_job_action.php?organisation=${organisation}&`,
    get_roles: `${host}get_roles.php?organisation=${organisation}&`,

    // Items
    get_items: `${host}get_items.php?organisation=${organisation}&`,
    create_item: `${host}create_item.php?organisation=${organisation}&`,
    remove_item: `${host}remove_item.php?organisation=${organisation}&`,

    //Employees
    get_employees_url: `${host}get_users.php?organisation=${organisation}&type=EMPLOYEE&`,
    create_employee: `${host}create_user.php?organisation=${organisation}&type=EMPLOYEE&`,
    remove_employee: `${host}remove_user.php?organisation=${organisation}&type=EMPLOYEE&`,

    //Employees
    get_contractors_url: `${host}get_users.php?organisation=${organisation}&type=CONTRACTOR&`,
    create_contractor: `${host}create_user.php?organisation=${organisation}&type=CONTRACTOR&`,
    remove_contractor: `${host}remove_user.php?organisation=${organisation}&type=CONTRACTOR&`,

    //Projects
    get_projects_url: `${host}get_projects.php?organisation=${organisation}&`,
    get_project_names: `${host}get_project_names.php?organisation=${organisation}&`,
    total_count: `${host}total_count.php?organisation=${organisation}&`,
    remove_project: `${host}remove_project.php?organisation=${organisation}&`,
    create_project: `${host}create_project.php?organisation=${organisation}&t`,
    change_project_status: `${host}change_project_status.php?organisation=${organisation}&`,
    get_project_job_status_transactions: `${host}get_project_job_status_transactions.php?organisation=${organisation}&`,
    get_project_info: `${host}get_project_info.php?organisation=${organisation}&`,
    get_project_store_transactions: `${host}get_project_store_transactions.php?organisation=${organisation}&`,

    //Job Status Transactions
    get_job_status_transactions: `${host}get_job_status_transactions.php?organisation=${organisation}&`,
    create_job_status_transaction: `${host}create_job_transactions.php?organisation=${organisation}&`,

    //Store Transactions
    get_store_transactions: `${host}get_store_transactions.php?organisation=${organisation}&`,
    create_store_transaction: `${host}create_store_transactions.php?organisation=${organisation}&`,

    defaultAlerts: {
        import: {
            hr: "18",
            min: "0"
        }
    }
}

export default Config;

export const RowCountOptions = [10, 25, 50, 100];